import { ViewModelItem } from '@workspace/view-model-folder/ui/ViewModelItem';
import type { ViewModelAndWorkspace } from '../ViewModelPage/hooks/useTagAssignedViewModels';

type Props = {
  viewModelAndWorkspaces: ViewModelAndWorkspace[];
};

export const ViewModelList: React.FC<Props> = ({ viewModelAndWorkspaces }: Props) => {
  return (
    <>
      {viewModelAndWorkspaces.map(({ viewModel, workspace }) => (
        <ViewModelItem
          key={viewModel.id}
          viewModel={viewModel}
          showEditMenu={false}
          noMenu={true}
          workspace={workspace}
          showConfigureIndividualPermissions={false}
        />
      ))}
    </>
  );
};
